import { render, staticRenderFns } from "./candidate-component.vue?vue&type=template&id=81875efa&scoped=true"
import script from "./candidate-component.ts?vue&type=script&lang=ts&external"
export * from "./candidate-component.ts?vue&type=script&lang=ts&external"
import style0 from "./candidate-component.scss?vue&type=style&index=0&id=81875efa&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81875efa",
  null
  
)

export default component.exports